'use client';
import React, { useEffect } from 'react';
import SnackbarAlert from '@modules/snackbar-alert';
import '../styles/globals.css';
import PushNotificationLayout from '@layouts/push-notification';
import { Provider } from 'react-redux';
import { fetchApi } from '../api/fetch';
import { SWRConfig } from 'swr';
import store from '@store/store';
import { usePathname } from 'next/navigation';
import { HomeActions } from '@store/home-screen/home-action';
import { ProgressProvider } from '@bprogress/next/app';

const ClientLayout = ({ children }: { children: any }) => {
  const pathname = usePathname();

  useEffect(() => {
    store.dispatch(HomeActions.setRouteAffix({ isMobileRoute: pathname.startsWith('/mobile') }));
  }, [pathname]);

  return (
    <Provider store={store}>
      <SnackbarAlert/>
      <ProgressProvider
        height={'4px'}
        color={'#27d4a8'}
        options={{ showSpinner: false }}
        shallowRouting={true}
        disableSameURL={true}>
        <SWRConfig value={{ fetcher: fetchApi, dedupingInterval: 10000 }}>
          <PushNotificationLayout>
            {children}
          </PushNotificationLayout>
        </SWRConfig>
      </ProgressProvider>
    </Provider>
  );
};

export default ClientLayout;
